var POSTCODE_REGEXP = /^[0-9]{4}$/;

function postcode() {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$validators.postcode = function(modelValue, viewValue) {

                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }

                return POSTCODE_REGEXP.test(viewValue);
                
            };
        }
    };
}

export default angular.module('postcode', []).directive('postcode', postcode).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/postcode.directive.js
 **/